import React from 'react';

function Malawi(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124046)">
        <mask
          id="mask0_800_124046"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124046)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#E11C1B"
          />
          <mask
            id="mask1_800_124046"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124046)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V10H36V0H0Z"
              fill="#272727"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#5EAA22"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.50204 11.9459V11.9434L4.49146 11.9451L4.50204 11.9459ZM5.20901 8.12682H5.3249L5.14727 8.10264L5.20901 8.12682ZM8.50244 8.12682C8.56134 8.02617 8.62284 7.92661 8.68687 7.8282L6.11125 6.31269L9.14917 7.19112C9.31907 6.97993 9.50123 6.77518 9.69489 6.57743L7.46244 4.68812L10.3074 6.00774C10.5161 5.8306 10.7348 5.66057 10.9629 5.49818L9.15741 3.28113L11.7073 5.01503C11.9445 4.87487 12.1896 4.74227 12.4422 4.6177L11.1417 2.13696L13.2957 4.23867C13.5524 4.13664 13.8152 4.04246 14.0837 3.95654L13.3515 1.29236L15.0194 3.69631C15.2879 3.63252 15.561 3.57673 15.8382 3.5293L15.7158 0.774497L16.8252 3.3979C17.0992 3.37165 17.3763 3.35345 17.6564 3.34361L18.1587 0.600006L18.6611 3.34442C18.9408 3.35469 19.2176 3.37331 19.4912 3.39996L20.6015 0.774497L20.479 3.53309C20.7552 3.58083 21.0273 3.63687 21.2948 3.70085L22.9658 1.29236L22.2318 3.96309C22.4987 4.04901 22.76 4.1431 23.0152 4.24495L25.1756 2.13696L23.8706 4.62642C24.1211 4.75054 24.3643 4.88257 24.5997 5.02205L27.1599 3.28113L25.3462 5.50819C25.5721 5.6696 25.7888 5.83851 25.9956 6.0144L28.8549 4.68812L26.6103 6.58771C26.8018 6.7839 26.982 6.98696 27.1501 7.19633L30.2061 6.31269L27.6144 7.83765C27.6762 7.93299 27.7357 8.02939 27.7927 8.12682H25.5822C24.0589 6.24981 21.2746 4.99318 18.0922 4.99318C14.9099 4.99318 12.1256 6.24981 10.6023 8.12682H8.50244ZM11.8798 8.12682C13.3231 6.80363 15.5892 5.95107 18.1374 5.95107C20.6856 5.95107 22.9518 6.80363 24.3951 8.12682H11.8798ZM30.9924 8.12682H31.1083L31.17 8.10264L30.9924 8.12682ZM31.817 11.9437L31.8259 11.9451L31.817 11.9458V11.9437Z"
              fill="#E11C1B"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124046">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Malawi;
